import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=26a21070&"
import script from "./TopBar.vue?vue&type=script&lang=ts&"
export * from "./TopBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a21070')) {
      api.createRecord('26a21070', component.options)
    } else {
      api.reload('26a21070', component.options)
    }
    module.hot.accept("./TopBar.vue?vue&type=template&id=26a21070&", function () {
      api.rerender('26a21070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/TopBar.vue"
export default component.exports